<span class="custom-container">
  <mat-icon *ngIf="data.icon">{{data.icon}}</mat-icon>
  <span *ngIf="!data.includeInnerHtml">{{ data.message | translate}}</span>
  <span *ngIf="data.includeInnerHtml" [innerHTML]="data.message | translate"></span>
  <mat-icon *ngIf="data.dismissFn" (click)="dismiss()">close</mat-icon>
</span>
